import React, { useEffect, useMemo, useState } from 'react';
import DataTable, { SortOrder } from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import moment from 'moment';
import { use } from 'react';
import Popup from '../common/popup';
import discountIcon from '../assets/images/discount-icon.png';

export const PromoOrders = ({ }) => {

    const priceFormat = (price) => {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2,
        });
    };

    // const columns = [
    //     {
    //         name: "Account Code",
    //         selector: row => row.accountCode,
    //         sortable: false,
    //     },
    //     {
    //         name: "Account Name",
    //         selector: row => row.accountName,
    //         sortable: false,
    //     },

    //     {
    //         name: "Order ID",
    //         selector: row => row.OrderNumber,
    //         cell: row => (
    //             <div style={{ display: "flex" }}>
    //                 <a className='button' data-title='View Order Details' onClick={() => getOrderDetails(row)}>
    //                     {row.OrderNumber}
    //                 </a>
    //             </div>
    //         ),
    //         sortable: true,
    //     },
    //     {
    //         name: "Ordered Date",
    //         selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
    //         sortable: false,
    //     },
    //     {
    //         name: "Spend Before Promo",
    //         selector: row => priceFormat(parseFloat(row.offerConvertFrom)),
    //         // sortFunction: (a, b) => parseFloat(a) - parseFloat(b),
    //         sortable: false,
    //     },
    //     {
    //         name: "Spend After Promo",
    //         selector: row => priceFormat(parseFloat(row.OrderTotalWithVat)),
    //         // sortFunction: (a, b) => {
    //         //     const totalA = parseFloat(a.OrderTotalWithVat) || 0;
    //         //     const totalB = parseFloat(b.OrderTotalWithVat) || 0;
    //         //     return totalA - totalB;
    //         // },
    //         sortable: false,
    //     },

    //     {
    //         name: "Difference in Spend",
    //         selector: row => priceFormat(parseFloat(row.OrderTotalWithVat) - parseFloat(row.offerConvertFrom)),
    //         // sortFunction: (a, b) => a - b,
    //         sortable: false,
    //     },
    // ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells

            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells

            },
        },
    };

    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
    const getFiscalMonthNumber = () => {
        const currentMonth = new Date().getMonth(); // 0 = Jan, 1 = Feb, ..., 3 = Apr
        // Fiscal month index: starts from Sep (8), wraps around
        const fiscalIndex = (currentMonth - 8 + 12) % 12;
        const fiscalMonthNumber = ((fiscalIndex + 8) % 12) + 1;
        return fiscalMonthNumber.toString(); // For useState
    };

    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [filter, setFilter] = useState(0);
    const [filtertext, setFilterText] = useState('');
    const [temporders, setTempOrders] = useState([]);
    const searchInputRef = React.createRef();
    const [promoOrders, setPromoOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sector, setSector] = useState("All");
    const [sectorList, setSectorList] = useState([]);
    const [filterType, setFilterType] = useState("order"); // default
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [offerRange, setOfferRange] = useState("all"); // Default to 250
    const [searchInput, setSearchInput] = useState('');
    const [allCustomers, setAllCustomers] = useState([]); // Store full unfiltered records
    const [months, setMonths] = useState('9');
    const [quarter, setQuarter] = useState('');
    const [popupView1, setPopupView1] = useState('');
    const [alertPopup, setAlertPopup] = useState(false);
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const [orderDetail, setOrderDetail] = useState({})
    const [analysisType, setAnalysisType] = useState('cart');
    const [mainDepot, setMainDepot] = useState("");
    const [subDepotList, setSubDepotList] = useState([]);
    const [mainDepotList, setMainDepotList] = useState([]);
    const [depots, setDepots] = useState([]);
    const [subDepot, setSubDepot] = useState("");
    const [orderDetailPopup, setOrderDetailPopup] = useState({
        headMoreTxt: '',
        closeButton: (<>
            <div className="order-top">
                <div className="head">
                    <h4>Order Details - {orderDetail?.OrderNumber}</h4>
                </div>
                <span onClick={(e) => closeOrderDetail()} className='close'></span>
            </div>
        </>),
        bodyMoreTxt: (<div className='loading-buffer'></div>)
    });

    const fetchSectors = async () => {
        try {
            let URL = BaseUrl + "admin/product/masterentries/sectors";

            const response = await http.get(URL);
            const data = response.data.data;

            setSectorList(data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchSectors();
    }, []);

    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
    // const fiscalMonthMap = MonthNames.reduce((acc, name, index) => {
    //     const monthNumber = ((index + 8) % 12) + 1;
    //     acc[monthNumber] = name;
    //     return acc;
    //   }, {});

    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
    };

    const columns = useMemo(() => {
        if (analysisType === 'sector') {
            return [
                {
                    name: "Account Code",
                    selector: row => row.accountCode,
                    sortable: false,
                },
                {
                    name: "Account Name",
                    selector: row => row.accountName,
                    sortable: false,
                },
                {
                    name: "Order ID",
                    selector: row => row.OrderNumber,
                    cell: row => (
                        <div style={{ display: "flex" }}>
                            <a className='button' data-title='View Order Details' onClick={() => getOrderDetails(row)}>
                                {row.OrderNumber}
                            </a>
                        </div>
                    ),
                    sortable: true,
                },
                {
                    name: filterType === "order" ? "Ordered Date" : "Delivery Date",
                    selector: (row) =>
                        filterType === "order"
                            ? moment(row.createdAt).format("DD/MM/YYYY")
                            : row.DateRequired,
                    sortable: false,
                },
                {
                    name: "Sector",
                    selector: row => row.client?.Sectors,
                    sortable: false,
                    style: {
                        justifyContent: 'flex-start', // LEFT align (fix issue)
                        textAlign: 'left',
                    }
                },
                {
                    name: "Order Amount",
                    selector: row => priceFormat(parseFloat(row.OrderTotalWithVat || 0)),
                    sortable: false,
                },
                {

                    name: "Main / Local Depot",
                    selector: row => (row.client?.mainDepot && row.client?.subDepot)
                        ? `${row.client.mainDepot} / ${row.client.subDepot}`
                        : "-",
                    sortable: false,
                },

            ];
        } else {
            return [
                {
                    name: "Account Code",
                    selector: row => row.accountCode,
                    sortable: false,
                },
                {
                    name: "Account Name",
                    selector: row => row.accountName,
                    sortable: false,
                },
                {
                    name: "Order ID",
                    selector: row => row.OrderNumber,
                    cell: row => (
                        <div style={{ display: "flex" }}>
                            <a className='button' data-title='View Order Details' onClick={() => getOrderDetails(row)}>
                                {row.OrderNumber}
                            </a>
                        </div>
                    ),
                    sortable: true,
                },
                {
                    name: filterType === "order" ? "Ordered Date" : "Delivery Date",
                    selector: (row) =>
                        filterType === "order"
                            ? moment(row.createdAt).format("DD/MM/YYYY")
                            : row.DateRequired,
                    sortable: false,
                },
                {
                    name: "Spend Before Promo",
                    selector: row => priceFormat(parseFloat(row.offerConvertFrom)),
                    // sortFunction: (a, b) => parseFloat(a) - parseFloat(b),
                    sortable: false,
                },
                {
                    name: "Spend After Promo",
                    selector: row => priceFormat(parseFloat(row.OrderTotalWithVat)),
                    // sortFunction: (a, b) => {
                    //     const totalA = parseFloat(a.OrderTotalWithVat) || 0;
                    //     const totalB = parseFloat(b.OrderTotalWithVat) || 0;
                    //     return totalA - totalB;
                    // },
                    sortable: false,
                },
                {
                    name: "Difference in Spend",
                    selector: row => priceFormat(parseFloat(row.OrderTotalWithVat) - parseFloat(row.offerConvertFrom)),
                    // sortFunction: (a, b) => a - b,
                    sortable: false,
                },
            ];
        }
    }, [analysisType, filterType]);

    const changeMainDepotHandler = (e) => {
        setSubDepot("");
        setMainDepot(e.target.value);
    }
    const changeSubDepotHandler = (e) => {
        setSubDepot(e.target.value);
    }

    useEffect(() => {

        let URL = BaseUrl + `admin/getdepots`;
        http
            .get(URL)
            .then((response) => {
                let responseData = response.data.data;

                const uniqueDepots = Array.from(new Set(responseData.map(item => item.mainDepot)))
                    .map(mainDepot => responseData.find(item => item.mainDepot === mainDepot));
                setSubDepotList(responseData);
                setDepots(responseData);
                setMainDepotList(uniqueDepots);

            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    useEffect(() => {
        if (mainDepot === "") {
            setSubDepotList(depots);
        } else {
            setSubDepotList(depots.filter(item => item.mainDepot === mainDepot));
        }
    }, [mainDepot, mainDepotList]);

    const getFiscalYearRange = (periodStr) => {
        const [start, end] = periodStr.split("-");
        const startDate = new Date(parseInt(start), 8, 1); // Sept 1
        const endDate = new Date(parseInt(end), 7, 31, 23, 59, 59, 999); // Aug 31
        return { startDate, endDate };
    };

    const getQuarterDateRange = (fiscalYearStartYear, quarter) => {
        const fiscalStartMonth = 8; // September
        const quarterIndex = parseInt(quarter) - 1;
        const startMonth = (fiscalStartMonth + quarterIndex * 3) % 12;
        const startYear = fiscalYearStartYear + Math.floor((fiscalStartMonth + quarterIndex * 3) / 12);
        const start = new Date(startYear, startMonth, 1);

        // Adjust end month/year correctly even when wrapping around year-end
        const tempEndMonth = startMonth + 2;
        const endMonth = tempEndMonth % 12;
        const endYear = startYear + Math.floor(tempEndMonth / 12);
        const end = new Date(endYear, endMonth + 1, 0, 23, 59, 59, 999);

        return { start, end };
    };

    const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };


    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
                if (selectedFiscalYear === currentFiscalYear) {
                    return Number(quarterNumber) <= currentQuarter;
                }
                return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
                <option key={quarterNumber} value={quarterNumber}>
                    {label}
                </option>
            ));
    };
    useEffect(() => {
        const now = new Date();
        const month = now.getMonth() + 1;
        const fiscalQuarterMap = {
            9: 1, 10: 1, 11: 1,
            12: 2, 1: 2, 2: 2,
            3: 3, 4: 3, 5: 3,
            6: 4, 7: 4, 8: 4
        };
        const currentFiscalQuarter = fiscalQuarterMap[month];
        setQuarter(currentFiscalQuarter);
    }, []);

    useEffect(() => {


        if (filter === "custom" && (!fromDate || !toDate)) {
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }
        setIsLoading(true);
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd"),
                sector: sector,
                mainDepot: mainDepot,
                subDepot: subDepot,
                filterType: filterType,
            }
            setShowDatePicker(false);
        }
        else if (filter === 'monthly') {
            payload = {
                filter: filter,
                datefrom: "",
                dateto: "",
                period: period,
                month: months,
                sector: sector,
                mainDepot: mainDepot,
                subDepot: subDepot,
                filterType: filterType,
            };
        }
        else if (["weekly", "quarterly", "FYdata"].includes(filter)) {
            payload = {
                filter: filter,
                datefrom: "",
                dateto: "",
                quarter: filter === 'quarterly' ? quarter : '',
                period: period,
                sector: sector,
                mainDepot: mainDepot,
                subDepot: subDepot,
                filterType: filterType,
            };
        }
        else {
            payload = {
                filter: parseInt(filter), datefrom: '',
                dateto: '',
                sector: sector,
                mainDepot: mainDepot,
                subDepot: subDepot,
                filterType: filterType,
            }
        }
        // let URL2 = BaseUrl + "admin/getpromoorders";

        // http.post(URL2, payload).then((response) => {
        //     setIsLoading(false);
        //     const data = response.data.data.filter((item) => parseFloat(item.offerConvertFrom) > 0 && (parseFloat(item.OrderTotalWithVat) - parseFloat(item.offerConvertFrom)) > 0);
        //     setPromoOrders(data.sort((a, b) => parseInt(b.OrderNumber) - parseInt(a.OrderNumber)));
        //     setTempOrders(data.sort((a, b) => parseInt(b.OrderNumber) - parseInt(a.OrderNumber)));

        let URL2 = analysisType === 'sector' ? BaseUrl + "admin/getSectorPromoOrders" : BaseUrl + "admin/getpromoorders";
        http.post(URL2, payload).then((response) => {
            setIsLoading(false);
            let data = response.data.data;

            if (analysisType === 'cart') {
                data = data.filter((item) => parseFloat(item.offerConvertFrom) > 0 && (parseFloat(item.OrderTotalWithVat) - parseFloat(item.offerConvertFrom)) > 0);
            }
            // sorting for BOTH cart & sector
            data = data.sort((a, b) => {
            const dateA = filterType === "order" ? new Date(a.createdAt) : moment(a.DateRequired, "DD/MM/YYYY").toDate();
            const dateB = filterType === "order" ? new Date(b.createdAt) : moment(b.DateRequired, "DD/MM/YYYY").toDate();
            return dateB - dateA;
        });
            //console.log("Fetched Promo Orders:", data);
            setPromoOrders(data);
            setTempOrders(data);

        }).catch((err) => {
            console.log(err);
        })

    }, [filter, fromDate, toDate, months, quarter, period, analysisType, sector, mainDepot, subDepot, filterType]);

    useEffect(() => {
        setSearchInput('');
        setSector("All");
        setMainDepot('');
        setSubDepot('');
    }, [analysisType]);

    const totalBeforeSpend = useMemo(() => {
        return promoOrders.reduce((total, order) => {
            return total + parseFloat(order.offerConvertFrom || 0);
        }, 0);
    }, [promoOrders]);

    const totalAfterSpend = useMemo(() => {
        return promoOrders.reduce((total, order) => {
            return total + parseFloat(order.OrderTotalWithVat || 0);
        }, 0);
    }, [promoOrders]);

    const totalDifference = useMemo(() => {
        return promoOrders.reduce((total, order) => {
            return total + (parseFloat(order.OrderTotalWithVat || 0) - parseFloat(order.offerConvertFrom || 0));
        }, 0);
    }, [promoOrders]);


    const closeOrderDetail = (e) => {
        setOrderDetail({});
        setShowOrderDetail(false);
       }
    
        const getOrderDetails=(stripelog)=>{
             setOrderDetailPopup( {
                headMoreTxt:'',
                closeButton:(<>
                            <div className="order-top">
                                    <div className="head">
                                        <h4>Order Details - {stripelog.OrderNumber}</h4>
                                    </div>
                                    <span  onClick={(e) => closeOrderDetail()} className='close'></span>
                                </div>
                            </>),
                bodyMoreTxt:(<div className='loading-buffer'></div>)
            });
            setOrderDetail({orderNumber:stripelog.OrderNumber})
            
            setShowOrderDetail(true);
            var numberOfAjaxCAllPending = 0;
            var timeInterval = 20000;
            var current = this;
            var loginDetails = {};
            if (sessionStorage.getItem('authData')) {
                loginDetails = JSON.parse(sessionStorage.getItem('authData'));
            }
    
           var URL = BaseUrl + "admin/getorderdetails/"+stripelog.OrderNumber;
           http.get(URL).then((response) => {
                numberOfAjaxCAllPending++;
                let responseData = [];
                responseData = response.data.data[0];
                 
                //  clearInterval(myInterval);
                  setIsLoading(false);
                //  current.setState({isLoading:false})
                viewOrderlogDetails(responseData);
                setAlertPopup(false);
    
            }).catch((err) => {
                console.log(err);
                setAlertPopup(false);
                setIsLoading(false);
            });

            // var myInterval = setInterval(function() {
            //     if(numberOfAjaxCAllPending == 0){
            //       numberOfAjaxCAllPending++;
            //       timeInterval = '';
            //       setAlertPopup(true);
            //       setIsLoading(false);
            //     //   current.setState({alertPopup: true,isLoading:false});
            //     }},timeInterval);
        }
     const  vatAmountCalcuation=(order)=>{
        //var old_order = order;
        var totalAmount = 0;
        order.items.map((item, value)=>{
           if(item.TaxCode !=='' && item.TaxCode === 'T1'){
              totalAmount += item.LinePrice;
           }
         });
         return totalAmount;
        }
     const viewOrderlogDetails=(order)=>
        {

            var ordertotal = 0;
            var subTotal = 0;
            setAlertPopup(false);
            // setIsLoading(false);
            // this.setState({alertPopup: false, alertMessage: ''});
            order.items.map((item) => { ordertotal += item.LinePrice; });
            order.items.map((item) => { subTotal += item.UnitPrice * item.QuantityOrdered; });
            var vatTotalAmount = vatAmountCalcuation(order);
            var vatAmount = 0;
            if(vatTotalAmount > 0){
                vatAmount = (vatTotalAmount / 100) * 20; 
                ordertotal = ordertotal + vatAmount;
            }
    
            if(order.accountEmail !== undefined)
            {
            setOrderDetail((prev) => ({
                ...prev,
                oaccountName: order.accountName,
                oaccountEmail: order.accountEmail,
                oaccountAddress: order.accountAddress
                }));
                createPopup(order, subTotal, ordertotal, vatAmount, vatTotalAmount)                  
            }
            else{
                var loginDetails = {};
                if (sessionStorage.getItem('authData')) {
                    loginDetails = JSON.parse(sessionStorage.getItem('authData'));
                }
                let URL = BaseUrl + "admin/account/"+order.accountCode;
                http.get(URL).then((response) => {
                    let responseData = [];
                    responseData = response.data.data;
                    let addressFields = [
                        responseData.accountAddress1,
                        responseData.accountAddress2,
                        responseData.accountAddress3,
                        responseData.accountAddress4,
                        responseData.accountAddress5,
                      ];
                     setOrderDetail((prev) => ({
                    ...prev,
                    oaccountName: responseData.accountName,
                    oaccountEmail: responseData.accountEmail,
                    oaccountAddress: addressFields.filter(field => field !== undefined && field !="").join(", ")
                    }));
                    createPopup(order, subTotal, ordertotal, vatAmount, vatTotalAmount)
                  }).catch((err) => {
                    this.setState({ loading: false });
                });      
            }
        }

     const str_replace=(product_name)=>{

        if(product_name !==''){

          product_name =  product_name.replaceAll('amp;', '&');
          product_name = product_name.replaceAll("apos;'", "'' ");
          product_name = product_name.replaceAll("quot;'", "'' ");
           
          return product_name;

        }else{

            return product_name;
        }
    }
    const   createPopup = (order, subTotal, ordertotal, vatAmount, vatTotalAmount) => {  
          // Sort order items to move those with UnitPrice 0 to the end
        const sortedItems = [...order.items].sort((a, b) => {
            if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
            if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
            return 0;
          });     
        // let popupResult = <Popup
        //     extClass="order-pop"
            let headMoreTxt=(
                <>
                 <div className="order-top">
                 <div className="bottom order-flex">
                    {/* Changed by K2b sangeetha for getting account details of particular order  */}
                         <div className='order_no_details'>
                             <h3>Order No - {order.OrderNumber}</h3>
                             <p>Order Placed on: <span className="date"> {moment(order.createdAt).format('DD/MM/YYYY hh:mm A')}</span> </p>
                             <p>Order Delivery on: <span className="date"> {order.DateRequired} </span></p>
                             
                             {order.PaymentMethod === 'A' &&
                               <p>Payment Method:<span className="pay"> {order.OrderPaid === 'YES' ? 'Paid (Pay Later)':'Pay Later'}</span></p>
    
                             }
                             {order.PaymentMethod === 'K' &&
                               <p>Payment Method:<span className="pay"> Online Payment</span></p>
                             }
    
                             <p>Status:<span className="pay"> {order.OrderStatus}</span></p>
                         </div>
    
                         <div className='order_account_details'>
                             
                             <p>Name: <span className="date">{ order.accountName}</span> </p>
                             <p>Account Code: <span className="date">{order.accountCode}</span> </p>
                             <p>Email Address: <span className="pay"> {order.accountEmail}</span></p>
                             <p>Address: <span className="pay">{order.accountAddress}</span></p>
                              {order.PODetails && (<p>
                                    PO Details:{" "}
                                    <span className="pay">{order.PODetails}</span>
                                </p>)}
                         </div>
                    {/* Changed by K2b sangeetha for getting account details of particular order  */}
    
                    </div>
    
                 </div>
                </>
            )
            let closebtn=(<>
                    <div className="pop-header-top order-top">
                        <div className="head">
                            <h4>Order Details - {order.OrderNumber} </h4>
                        </div>
                    <span onClick={(e) => closeOrderDetail()} className='close'></span> 
                    </div>
    
            </>)

                      

           let bodyMoreTxt=(
                <>
                                 
                    <div className="modal-table">
                        <h4 className="item-title">Ordered Items</h4>
                        <div className="checkout-table">
                            <div className="table_overflow">
                                <table>
                                    <thead>
                                        <tr>
                                            <td>Product</td>
                                            <td>Unit of Sale</td>
                                            <td>Quantity</td>
                                            <td align="center">Price</td>
                                            <td align="right">Total</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* Added Special offer and product number like frontend */}
                                    {sortedItems.map((item, index) => {
    
                                        return (item.QuantityOrdered > 0 && <tr key={index}
                                            className={item.UnitPrice === 0 ? 'free-prod-bg' : ''}>
                                            <td data-title="Product" className='data-product-hide'>{str_replace(item.Description)} ({(item.ProductNumber.includes('_')) ? item.ProductNumber.substring(0,item.ProductNumber.indexOf('_')) : item.ProductNumber}){item.TaxCode !=='' && item.TaxCode === 'T1' && <span className='color-red'>*</span>}
                                                {item.OfferFlag == "true" && <span className='offer-tag-wrap'><span className="offer-tag"><img src={discountIcon} alt="Offer" className="tag-icon" />Special Offer</span></span>}
    
                                            </td>
                                            <td data-title="Unit of Sale">{item.PricingUnit}</td>
                                            <td data-title="Quantity">{item.QuantityOrdered}</td>
                                            <td data-title="Price" align="center">{priceFormat(parseFloat(item.UnitPrice))}</td>
                                            <td data-title="Total" align='right'>{priceFormat(parseFloat(item.LinePrice))}</td>
    
                                        </tr>)
                                        })}
                                         {/* Added Special offer and product number like frontend */}
                                    </tbody>
                                    <thead className='ord-grand-total'>
                                    { order.OrderNote !=='' && order.OrderNote !== null && 
                                        <tr>
                                            <td  align="left" width={120} colSpan="7">Order Notes: <span className='order_remarks'> {this.getOrderNotes(order.OrderNote)}</span></td>
                                        </tr>
                                        }
                                        <tr>
                                            <td  align="right" width={120} colSpan="4">Subtotal:</td>
                                            <td align="right">{priceFormat(subTotal)}</td>
                                        </tr>
                                        {vatAmount > 0 && 
                                         <tr>
                                            <td align="right" width={120} colSpan="4" className='td-vat-fee'>
                                                <span className="strong">VAT <span className='vat-txt'>(20% of <span className='vat-amt'>{priceFormat(vatTotalAmount)}</span>)<span className='color-red'>*</span>:</span></span>
                                            </td>
                                            <td className='cart-prod-vat' align="right">{priceFormat(vatAmount)}</td>
                                          </tr>
                                          }
    
                                        
                                        <tr>
                                            <td  align="right" width={120} colSpan="4">Shipping:</td>
                                            <td align="right"><span className='color-red'>FREE</span></td>
                                        </tr>
                            
                                        <tr><td  align="right" width={120} colSpan="4">Grand Total:</td><td align="right">{priceFormat(ordertotal)}</td></tr>
                                        </thead>
                                </table>
                            </div>
                        </div>
    
                    </div>
                </>
            )
          setOrderDetailPopup({
            headMoreTxt:headMoreTxt,
            closeButton:closebtn,
            bodyMoreTxt:bodyMoreTxt
                        })
        }

    const changeFilterHandler = (e) => {

        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);

        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);

        }
    };

const changePeriodHandler = (e) => {
  const newPeriod = e.target.value;
  setPeriod(newPeriod); // update selected fiscal year in state
  //split fiscal year
  const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
  
  const fiscalStartMonthIndex = 8; // 0-based index for September

  const today = new Date();
  const currentFiscalYear = getCurrentFiscalYear();
  //compare sleted year with currentfiscalyear 
  const isCurrentFiscalYear = newPeriod === currentFiscalYear;

  // MONTHLY filter logic
  if (filter === 'monthly') {
    let visibleMonthNames = MonthNames;

    if (isCurrentFiscalYear) {
      // Calculate current fiscal month index 
      const currentMonthIndex = today.getMonth(); // 0-based
      const monthsPassedSinceFiscalStart =
        (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
      const maxVisibleIndex = monthsPassedSinceFiscalStart;

      visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
    }

    const selectedMonthIndex = MonthNames.indexOf(months);
    const isValidMonth =
      selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;

    if (!isValidMonth) {
      const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
      setMonths(String(defaultMonthNumber));
    }
  }

  // QUARTERLY filter logic
  if (filter === 'quarterly') {
    const currentQuarter = getCurrentFiscalQuarter();
    let maxQuarter = 4;

    if (isCurrentFiscalYear) {
      maxQuarter = currentQuarter;
    }

if (parseInt(quarter) > maxQuarter) {
  setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
}

  }
};

    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };

    const changeOfferRangeHandler = (e) => {
        setOfferRange(e.target.value.trim());
    };

    useEffect(() => {
        let filteredOrders = temporders;
        // Apply search filter if searchInput is not empty
        if (searchInput !== '') {
            const lowercasedValue = searchInput.toLowerCase();
            filteredOrders = filteredOrders.filter((item) =>
                item.accountCode.toLowerCase().includes(lowercasedValue)
            );
        }

        // Apply offer range filter if offerRange is set
        if (offerRange !== '') {
            filteredOrders = filteredOrders.filter((item) => {
                const offerConvertFrom = analysisType === 'sector'
                    ? parseFloat(item.OrderTotalWithVat)
                    : parseFloat(item.offerConvertFrom);
                if (offerRange === "250") {
                    return offerConvertFrom < 250;
                } else if (offerRange === "250-500") {
                    return offerConvertFrom >= 250 && offerConvertFrom <= 500;
                } else if (offerRange === "500-750") {
                    return offerConvertFrom > 500 && offerConvertFrom <= 750;
                } else if (offerRange === "750-1000") {
                    return offerConvertFrom > 750 && offerConvertFrom <= 1000;
                } else if (offerRange === "1000") {
                    return offerConvertFrom > 1000;
                }
                return true;
            });
        }
        setPromoOrders(filteredOrders);
    }, [searchInput, temporders, offerRange, analysisType]);
    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = String(dateObject.getMonth() + 1).padStart(2, "0");
        const day = String(dateObject.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    // Calculate dynamic pagination options
    const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };

    const totalRecords = promoOrders.length; // Get the total records count
    const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
        }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);

    };
    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    return (
        <div className={`chart-container chart-promo-offers ${loadingbuffer}`} style={{ verticalAlign: "top" }}>
            <div className="chart-Hdr">
                <div className="chart-Hdr-txt chart-fltr">

                    {/* <h2>Promo Offer Spend Analysis</h2> */}
                    <select
                        value={analysisType}
                        onChange={(e) => setAnalysisType(e.target.value)}
                    >
                        <option value={"cart"}>Streetfood Sauces Promo</option>
                        <option value={"sector"}>PINSA Promo</option>
                    </select>

                    <div className="chart-fltr" style={{ width: "190px" }}>
                        <input
                            type="text"
                            value={searchInput}
                            onChange={handleChange}
                            placeholder={`Search by Account Code`}
                        />
                    </div>
                </div>
                {/* New Sort Filter Dropdown */}
                <div className="chart-fltr-Hldr">
                    {analysisType === 'sector' && (
                        <>
                            <div className="chart-fltr">
                                {<select name="mainDepot" value={mainDepot} onChange={(e) => changeMainDepotHandler(e)}>
                                    <option value="">Select Main Depot</option>
                                    {mainDepotList.map(item => (
                                        <option key={item.mainDepot} value={item.mainDepot}>{item.mainDepot}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="chart-fltr">
                                {<select name="subDepot" value={subDepot} onChange={(e) => changeSubDepotHandler(e)}>
                                    <option value="">Select Local Depot</option>
                                    {subDepotList.map(item => (
                                        <option key={item.subDepot} value={item.subDepot}>{item.subDepot}</option>
                                    ))}
                                </select>}
                            </div>
                            <div className="chart-fltr">
                                <select value={sector} onChange={(e) => setSector(e.target.value)}>
                                    <option value="All">All</option>
                                    {sectorList.map((item) => (
                                        <option key={item._id} value={item.MasterValue}>
                                            {item.MasterValue}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </>
                    )}

                    <div className="chart-fltr" >
                        {<select
                            value={offerRange}
                            onChange={(e) => changeOfferRangeHandler(e)}
                        ><option value={"all"}>All (£)</option>
                            <option value={"250"}>Below £250</option>
                            <option value={"250-500"}>£251 - £500</option>
                            <option value={"500-750"}>£501 - £750</option>
                            <option value={"750-1000"}>£751 - £1000</option>
                            <option value={"1000"}>Above £1000</option>
                        </select>}
                    </div>
                    <div className="chart-fltr">
                        <select
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                        >
                            <option value="order">Ordered Date</option>
                            <option value="delivery">Delivery Date</option>
                        </select>
                    </div>
                    <div className="chart-fltr" onMouseEnter={() => {
                        if (filter === "custom" && !showDatePicker) {
                            setShowDatePicker(true);
                        }
                    }}
                        onMouseLeave={() => {
                            if (filter === "custom" && showDatePicker) {
                                setShowDatePicker(false);

                            }
                        }}>
                        {<select
                            value={filter}
                            onChange={(e) => changeFilterHandler(e)}
                        ><option value={0}>All</option>
                            <option value={"weekly"}>Current Week</option>
                            <option value={"monthly"}>Monthly</option>
                            <option value={"quarterly"}>Quarterly</option>
                            <option value={"FYdata"}>FY Data</option>
                            <option value={30}>Past 30 Days</option>
                            <option value={90}>Past 90 Days</option>
                            <option value={180}>Past 180 Days</option>
                            <option value={365}>Past 1 Year</option>
                            <option value={'custom'}>Custom Date</option>
                        </select>}
                        {showDatePicker && (
                            <div className="date-picker-container">
                                <label>From:</label>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => DateChange(date, "from")}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    maxDate={filterType === "delivery" ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) : new Date()}
                                    placeholderText="Select Date"
                                />
                                <label>To:</label>
                                <DatePicker
                                    selected={toDate}
                                    showDisabledMonthNavigation
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) => DateChange(date, "to")}
                                    maxDate={filterType === "delivery" ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) : new Date()}
                                    placeholderText="Select Date"
                                />
                            </div>
                        )}
                        {filter === 'quarterly' && (
                            <select
                                value={quarter}
                                onChange={(e) => setQuarter(Number(e.target.value))}
                            >
                                {/* {Object.entries(quarterNames).map(([q, label]) => (
                        <option key={q} value={q}>{label}</option>
                        ))} */}
                                {getAvailableQuarters(period)}
                            </select>
                        )}

                        {filter === 'monthly' && <select value={months} onChange={(e) => changeMonthHandler(e)}>
                            {visibleMonthNames.map((monthName, index) => {
                                const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                                return (
                                    <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                    </option>
                                );
                            })}
                        </select>

                        }
                        {(filter === 'monthly' || filter === 'quarterly' || filter === 'FYdata') && <select
                            value={period}
                            onChange={(e) => changePeriodHandler(e)}
                        >
                            {options}
                        </select>}
                    </div>
                </div>
                <div className="fltr-sub-val">
                    {promoOrders.length > 0 && (<span className='fltr-val' style={{ display: 'inline' }}>Total Records: <strong>{promoOrders.length}</strong> {(["Current Week", "Monthly", "Quarterly", 'FY Data'].includes(filtertext)) ? '' : (filtertext != '' && filtertext != 'Custom Date') ? ' (' + filtertext + ')' : (filtertext === 'Custom Date' && fromDate && toDate) ? ' (' + formatDate(fromDate) + ' - ' + formatDate(toDate) + ')' : ' (' + 'All' + ')'}</span>)}
                    {analysisType === 'cart' && totalBeforeSpend > 0 && (
                        <>
                            <span style={{ paddingLeft: '6px' }}> | </span>
                            <span className='fltr-val' style={{ display: 'inline', paddingLeft: '6px' }}> Total Spend Before Promo: <strong>{priceFormat(totalBeforeSpend)}</strong></span>
                        </>
                    )}
                    {totalAfterSpend > 0 && (
                        <><span style={{ paddingLeft: '6px' }}> | </span> <span className='fltr-val' style={{ display: 'inline', paddingLeft: '6px' }}> {analysisType === 'cart' ? 'Total Spend After Promo: ' : 'Total Order Amount: '} <strong>{priceFormat(totalAfterSpend)}</strong></span>
                        </>
                    )}
                    {analysisType === 'cart' && totalDifference > 0 && (
                        <><span style={{ paddingLeft: '6px' }}> | </span> <span className='fltr-val' style={{ display: 'inline', paddingLeft: '6px' }}> Total Difference in Spend: <strong>{priceFormat(totalDifference)}</strong></span>
                        </>
                    )}
                </div>
            </div>
            <DataTable
                className={analysisType === 'sector' ? 'sector-based-table' : ''}
                columns={columns}
                data={promoOrders}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                //paginationRowsPerPageOptions={paginationOptions}
                paginationComponentOptions={paginationComponentOptions}
            // paginationComponentOptions={{
            //     rowsPerPageText: '', // Hides "Rows per page"
            // }}
            />
            { (showOrderDetail === true) && (


                <Popup
                    extClass="order-pop my-order-details-pop"
                    headmoreText
                    headMoreTxt={
                        orderDetailPopup?.headMoreTxt
                    }

                    closebtn={orderDetailPopup?.closeButton}

                    bodyMoreTxt={orderDetailPopup?.bodyMoreTxt}
                />
            )
}
        </div>
    );
};